export default __webpack_public_path__ + "static/media/640_dummy-2014-store03-de.ef0f83b5.png";